import React, { useState } from "react";

export default function Button({
  size,
  variant,
  children,
  type = "button",
  ...props
}) {
  const [isHovered, setIsHovered] = useState(false);

  const sizes = {
    small: { padding: "10px 24px", fontSize: "12px", lineHeight: "130%" },
    medium: { padding: "14px 32px", fontSize: "14px", lineHeight: "120%" },
    large: { padding: "16px 40px", fontSize: "16px", lineHeight: "120%" },
  };

  const variants = {
    fill: {
      backgroundColor: isHovered ? "#2C742F" : "var(--primary)",
      color: "var(--white)",
      border: "none",
    },
    white: {
      backgroundColor: isHovered ? "var(--gray05)" : "var(--white)",
      color: "var(--primary)",
      border: "none",
    },
    border: {
      backgroundColor: "transparent",
      color: isHovered ? "#2C742F" : "var(--primary)",
      border: isHovered ? "2px solid #2C742F" : "2px solid var(--primary)",
    },
    ghost: {
      backgroundColor: isHovered ? "#2C742F33" : "#56AC591A",
      color: isHovered ? "#2C742F" : "var(--primary)",
      border: "none",
    },
  };

  return (
    <button
      type={type}
      {...props}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...sizes[size],
        ...variants[variant],
        borderRadius: "43px",
        cursor: "pointer",
        fontWeight: "600",
        width: "fit-content",
        height: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        ...props.style,
      }}
    >
      {children}
    </button>
  );
}
